export default content => {
  const richBlob = new Blob([content], { type: "text/html" }); // rich text
  const plainBlob = new Blob([content], { type: "text/plain" }); // plain text fallback
  const clipboardContent = new ClipboardItem({ "text/html": richBlob, "text/plain": plainBlob });
  return navigator.clipboard.write([clipboardContent]);
};
